import React from "react";
import { MantineProvider } from "@mantine/core";

import { Header } from "../../components/Header/Header";
import { Footer } from "../../components/Footer/Footer";
import TermsOfService from "./components/TermsOfService";

const theme = {};

const TermsOfServicePage = () => {
  return (
    <MantineProvider theme={theme}>
      {Header()}
      <TermsOfService />
      {Footer()}
    </MantineProvider>
  );
};

export default TermsOfServicePage;
